var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg090Transaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.29 3.28994C17.6821 2.89782 18.3179 2.89782 18.71 3.28994L21.71 6.28994C21.8993 6.47771 22.0058 6.7333 22.0058 6.99994C22.0058 7.26658 21.8993 7.52217 21.71 7.70994L18.71 10.7099C18.5222 10.8993 18.2666 11.0057 18 11.0057C17.7334 11.0057 17.4778 10.8993 17.29 10.7099C17.1007 10.5222 16.9942 10.2666 16.9942 9.99994C16.9942 9.7333 17.1007 9.47771 17.29 9.28994L18.59 7.99994H3C2.44772 7.99994 2 7.55223 2 6.99994C2 6.44766 2.44772 5.99994 3 5.99994H18.59L17.29 4.70994C16.8979 4.31782 16.8979 3.68206 17.29 3.28994ZM5.41 15.9999H21C21.5523 15.9999 22 16.4477 22 16.9999C22 17.5522 21.5523 17.9999 21 17.9999H5.41L6.71 19.2899C6.89931 19.4777 7.0058 19.7333 7.0058 19.9999C7.0058 20.2666 6.89931 20.5222 6.71 20.7099C6.52223 20.8993 6.26664 21.0057 6 21.0057C5.73336 21.0057 5.47777 20.8993 5.29 20.7099L2.29 17.7099C2.10069 17.5222 1.9942 17.2666 1.9942 16.9999C1.9942 16.7333 2.10069 16.4777 2.29 16.2899L5.29 13.2899C5.68212 12.8978 6.31788 12.8978 6.71 13.2899C7.10212 13.6821 7.10212 14.3178 6.71 14.7099L5.41 15.9999Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg090Transaction);
export default __webpack_public_path__ + "static/media/090-transaction.055a362c81968bd18591cc79d273ee2a.svg";
export { ForwardRef as ReactComponent };